function onHotspotTriggerClickHandler() {
  const sectionWrappers = document.querySelectorAll('[data-hotspot-section]');

  sectionWrappers.forEach(wrapper => {
    const triggerList = wrapper.querySelectorAll('[data-hotspot-item-trigger]');

    triggerList.forEach(trigger => {
      trigger.addEventListener("click", function () {
        const activeDetails = wrapper.querySelector('.custom-hotspot__hotspot-item-details-wrapper--unhide');
        if (activeDetails) {
          activeDetails.previousElementSibling.classList.remove("custom-hotspot__hotspot-item-trigger--active");
          activeDetails.classList.remove("custom-hotspot__hotspot-item-details-wrapper--unhide");
        }

        const detailsWrapper = this.nextElementSibling;
        if (!detailsWrapper) return;


        if (activeDetails && activeDetails.previousElementSibling == trigger){
          trigger.classList.remove("custom-hotspot__hotspot-item-trigger--active");
          detailsWrapper.classList.remove("custom-hotspot__hotspot-item-details-wrapper--unhide");
        }else{
          trigger.classList.add("custom-hotspot__hotspot-item-trigger--active");
          detailsWrapper.classList.add("custom-hotspot__hotspot-item-details-wrapper--unhide");
        }
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", onHotspotTriggerClickHandler);
} else {
  onHotspotTriggerClickHandler();
}
